<template>
  <div id="main">
    <div class="wrapper" v-if="$store.state.isLoggedIn">
      <template>
        <app-header @onTrigger="drawer = !drawer"></app-header>
        <v-navigation-drawer
          fixed
          v-model="drawer"
          dark
          app
          class="primary"
          :class="{ menu: true }"
        >
          <v-layout>
            <v-flex>
              <v-btn fab flat dark small @click="onGoHome">
                <v-icon>home</v-icon>
              </v-btn>
            </v-flex>
            <v-flex class="text-xs-right">
              <v-btn fab flat dark small @click="drawer = false" class="hidden-sm-and-up">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <ul class="home-m menu-list"></ul>

          <div class="text-xs-center" v-if="profile">
            <v-badge overlap class="mb-2" color="green">
              <template v-slot:badge>
                <span style="font-family: serif">I</span>
              </template>

              <v-avatar size="100px">
                <img
                  class="responsive-img circle"
                  style="min-width: 100%"
                  alt
                  @error="onError"
                  :src="profile.photo"
                />
              </v-avatar>
            </v-badge>
            <div class="white--text">{{ profile.fullname }}</div>

            <div class="px-3 mb-4">
              <div class="text-xs-center white--text">
                <div class="mt-4 mb-2 caption">Your Support Code</div>
                <div
                  class="primary lighten-2 py-2"
                  style="border-radius: 50px"
                  v-clipboard:copy="profile.code"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onCopyError"
                >
                  {{ profile.code ? profile.code : '-' }} <v-icon small>file_copy</v-icon>
                </div>
              </div>
            </div>

            <v-divider></v-divider>

            <div class="mt-4 text-xs-left">
              <div>
                <ul class="menu-list">
                  <router-link :to="'/' + $i18n.locale() + '/partner/profile'">
                    <li tabindex="0" class="icon-user">
                      <span>{{ $t('Profile') }}</span>
                    </li>
                  </router-link>

                  <router-link :to="'/' + $i18n.locale() + '/partner/blog'">
                    <li tabindex="0" class="icon-bookmark">
                      <span>{{ $t('Blog') }}</span>
                    </li>
                  </router-link>

                  <router-link :to="'/' + $i18n.locale() + '/partner/redeemcode'">
                    <li tabindex="0" class="icon-ticket">
                      <span>{{ $t('Redeem Code') }}</span>
                    </li>
                  </router-link>

                  <router-link :to="'/' + $i18n.locale() + '/partner/customer'">
                    <li tabindex="0" class="icon-customer">
                      <span>{{ $t('Customer') }}</span>
                    </li>
                  </router-link>

                  <li tabindex="0" class="icon-sign-out" @click="logout">
                    <span>{{ $t('Sign Out') }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </v-navigation-drawer>
        <v-content>
          <slot></slot>
        </v-content>
        <app-footer />
      </template>

      <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
        >{{ $t('Code Copied') }}!</v-snackbar
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import header from '@/components/elements/header'
import footer from '@/components/elements/footer'
export default {
  data() {
    return {
      drawer: null,
      showCopy: false
    }
  },
  components: {
    'app-header': header,
    'app-footer': footer
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang',
      loading: 'getLoadingPartnerProfile',
      profile: 'getPartnerProfile'
    }),
    isDefaultTheme() {
      return this.$vuetify.theme.primary == '#FF706B'
    }
  },
  async mounted() {
    this.$store.dispatch('loadPartnerProfile')
  },
  methods: {
    onGoHome() {
      location.href = '/' + this.$i18n.locale() + '/allbots'
    },
    onError: function (event) {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    onCopy: function () {
      let vm = this

      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 3000)
    },
    onCopyError: function () {},
    logout: function () {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to Logout?'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            var isFacebook = vm.isFacebook
            vm.$store.dispatch('logout', null).then()
            vm.$router.push('/' + vm.currentLang + '/login')
            // if (isFacebook) {
            // } else {
            //   vm.$router.push('/' + vm.currentLang + '/nigol')
            // }
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped></style>

<style lang="scss">
.menu.default {
  background-color: #ff846d !important;
}
.menu {
  .avatar {
    .bot-active {
      border: 3px solid #a0e83d;
    }

    .bot-inactive {
      border: 3px solid red;
    }
  }

  ul.menu-list {
    list-style: none;
    padding: 0.5em 0;
    margin: 0;

    .router-link-active {
      li {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }

    a {
      text-decoration: none;
    }
    li {
      font-size: 0.95em;
      font-weight: 300;
      background-repeat: no-repeat;
      background-position: left 15px center;
      background-size: auto 20px;
      transition: all 0.15s linear;
      padding: 1em 1em 1em 3em;
      cursor: pointer;

      &.icon-home {
        background-image: url('/static/img/assets/sidebar/home.svg');
      }

      &.icon-greeting {
        background-image: url('/static/img/assets/sidebar/greeting.svg');
      }

      &.icon-speech {
        background-image: url('/static/img/assets/sidebar/speech.svg');
      }

      &.icon-mailbox {
        background-image: url('/static/img/assets/sidebar/mailbox.svg');
      }

      &.icon-analytics {
        background-image: url('/static/img/assets/sidebar/analytics.svg');
      }

      &.icon-billing {
        background-image: url('/static/img/assets/sidebar/billing.svg');
      }

      &.icon-setting {
        background-image: url('/static/img/assets/sidebar/setting.svg');
      }
      &.icon-ticket {
        background-image: url('/static/img/assets/sidebar/ticket.svg');
      }

      &.icon-gym {
        background-image: url('/static/img/assets/sidebar/gym.svg');
      }

      &.icon-help {
        background-image: url('/static/img/assets/sidebar/help.svg');
      }

      &.icon-megaphone {
        background-image: url('/static/img/assets/sidebar/megaphone.svg');
      }

      &.icon-premium {
        background-image: url('/static/img/assets/sidebar/premium.svg');
      }

      &.icon-shop {
        background-image: url('/static/img/assets/sidebar/shop.svg');
      }

      &.icon-sign-out {
        background-image: url('/static/img/assets/sidebar/sign-out.svg');
      }

      &.icon-plugin {
        background-image: url('/static/img/assets/sidebar/plugin.svg');
      }

      &.icon-user {
        background-image: url('/static/img/assets/sidebar/user.svg');
      }

      &.icon-bookmark {
        background-image: url('/static/img/assets/sidebar/bookmark.svg');
      }

      &.icon-customer {
        background-image: url('/static/img/assets/sidebar/customer.svg');
      }

      span {
        width: 100%;
        color: white;
        margin-left: 10px;
      }

      &:hover {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }

    .devide {
      border-bottom: 1px solid #ff8c88;
    }
  }
}
h1,
h2,
h3,
h4,
h5,
h6 {
  color: var(--primary-color);
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/Partner.vue